import { Group } from '../group/group';
import { getLicenceTypes, LicenceType } from '../payment/payment';
import { Role } from '../role/role';

export enum UserActions {
  UPDATE_PASSWORD,
  VERIFY_EMAIL,
}

export class User {
  id: string;
  email: string;
  enabled: boolean;
  firstName: string;
  lastName: string;
  userName: string;
  initials: string;
  externalId: string;
  groups: Group[];
  roles: Role[];
  requiredActions: UserActions[];
  locationIds: string[];
  licenceType: LicenceType;
  displayName: string;
  preferredLanguage: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.email = payload.email;
      this.enabled = payload.enabled;
      this.firstName = payload.firstName;
      this.lastName = payload.lastName;
      this.userName = payload.userName;
      this.initials = payload.initials;
      this.externalId = payload.externalId;
      this.roles = payload.roles;
      if (payload.groups) {
        this.groups = new Array<Group>();
        payload.groups.map((group: any) => {
          this.groups.push(new Group(group));
        });
      }
      if (payload.roles) {
        this.roles = Role.createRoles(payload.roles);
      }
      this.requiredActions = payload.requiredActions;
      this.locationIds = payload?.locationIds;
      // #735: ohne diese Zuweisung kaeme ein selektiertes preferredLanguage nie in der
      // Komponente an — der Konstruktor kopiert Felder explizit.
      this.preferredLanguage = payload.preferredLanguage;
      if (payload.licenceType) {
        this.licenceType = getLicenceTypes().find(type => type.id === payload.licenceType);
      }
      if (this.firstName && this.lastName) {
        this.displayName = this.firstName + ' ' + this.lastName;
      } else {
        this.displayName = this.email;
      }
    }
  }

  static createUsers(result: Array<any>): User[] {
    const users = new Array<User>();
    if (result) {
      result.map((user) => {
        users.push(new User(user));
      });
    }
    return users;
  }

  static getStatusLabel(status: boolean): string {
    return this.getStatus().find(type => type.id === status)?.label;
  }

  static getStatus() {
    return [
      { label: 'core.user.state.enabled', id: true },
      { label: 'core.user.state.disabled', id: false },
    ];
  }

  static getLicenceType(label: string): any {
    switch (label) {
      case 'FULL_USER': return 'Full-User';
      case 'APP_USER': return 'App-User';
      case 'NO_LICENCE': return 'Keine Lizenz';
    }
  }

  static getLicenceTypes() {
    return [
      { label: 'Full User', name: 'FULL_USER' },
      { label: 'App User', name: 'APP_USER' },
      { label: 'Keine Lizenz', name: 'NO_LICENCE' },
    ];
  }
}

export class UserInput {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  initials: string;
  externalId: string;
  groupIds: string[];
  password: string;
  requiredActions: UserActions[];
  locationIds: string[];

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.email = payload.email;
      this.firstName = payload.firstName;
      this.lastName = payload.lastName;
      this.password = payload.password;
      this.initials = payload.initials;
      this.externalId = payload.externalId;
      this.groupIds = payload.groupIds;
      this.requiredActions = payload.requiredActions;
      this.locationIds = payload?.locationIds;
    }
  }

  static createUserInputFromUser(user: User): UserInput {
    return new UserInput({
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      initials: user.initials,
      externalId: user.externalId,
      groupIds: user.groups.map(group => group.id),
      roles: user.roles.map(role => role.id),
      requiredActions: user.requiredActions,
      locationIds: user.locationIds,
    });
  }
}
